import {AssigneeChangeNotificationDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {option, Option} from "ts-option";

/**
 * Assignee change notification class data.
 */
export default class AssigneeChangeNotificationData {
	/**
	 *
	 * @param {string} leadId
	 * @param {string} referenceNumber
	 * @param {string} creator Entity who changed assignees.
	 * @param {string[]} previousAssigneesIds
	 * @param {string[]} currentAssigneesIds
	 * @param {string} agentId
	 * @param {string} businessDevelopmentPartnerId
	 */
	constructor(readonly leadId: string,
		readonly referenceNumber: string,
		readonly creator: AuthenticatedEntity,
		readonly previousAssigneesIds: string[],
		readonly currentAssigneesIds: string[],
		readonly agentId: Option<string>,
		readonly businessDevelopmentPartnerId: Option<string>) {}

	static fromJson(json: AssigneeChangeNotificationDataApiDto): AssigneeChangeNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new AssigneeChangeNotificationData(json.leadId, json.referenceNumber, creator, json.previousAssignees,
			json.currentAssignees, option(json.agentId), option(json.businessDevelopmentPartnerId));
	}

	getLeadReferenceNumber() {
		return this.referenceNumber;
	}
}
